<template>
    <div>
        <v-dialog
            v-model="$props.params.editCredentialsDialog"
            max-width="600px"
            transition="dialog-bottom-transition"
            @keydown.esc="closeAddEditCredentialsDialog()"
            @click:outside="closeAddEditCredentialsDialog()"
        >
            <v-card>
                <v-form @submit.prevent="processAddEditCredentials()">

                    <v-toolbar
                        :class="dialogHeadingClasses()"
                        color="primary"
                        dark
                    >
                        <v-icon v-if="$props.params.mode === 'add'" class="mr-3"
                                v-text="icons.mdiPlusCircleOutline"></v-icon>
                        <v-icon v-else class="mr-3" v-text="icons.mdiMonitorEdit"></v-icon>
                        <div v-if="$props.params.mode === 'add'">{{ $gettext('Add Credentials') }}</div>
                        <div v-else-if="$props.params.mode === 'edit'">{{ $gettext('Edit Credentials') }}</div>
                        <v-spacer></v-spacer>
                        <v-icon class="mr-2" v-text="icons.mdiClose"
                                @click.native.stop="closeAddEditCredentialsDialog()"></v-icon>
                        <v-icon v-text="icons.mdiContentSave" @click.native.stop="processAddEditCredentials()"></v-icon>
                    </v-toolbar>

                    <v-divider></v-divider>

                    <v-card-text class="mt-4">
                        <v-container>

                            <v-row>
                                <v-col cols="12">

                                    <v-row>
                                        <v-col>
                                            <v-text-field
                                                v-model="editLogin"
                                                :error-messages="editLoginErrors"
                                                :label="$gettext('Login')"
                                                :placeholder="$gettext('Login')"
                                                autofocus
                                                outlined
                                                required
                                                @blur="$v.editLogin.$touch()"
                                                @input="$v.editLogin.$touch()"
                                            ></v-text-field>


                                            <v-text-field
                                                v-model="editPassword"
                                                :error-messages="editPasswordErrors"
                                                :label="$gettext('Password')"
                                                :placeholder="$gettext('Password')"
                                                outlined
                                                required
                                                @blur="$v.editPassword.$touch()"
                                                @input="$v.editPassword.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>


                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-actions color="secondary">
                        <v-spacer></v-spacer>
                        <v-btn class="primary" @click.native.stop="closeAddEditCredentialsDialog()">
                            {{ $gettext('Close') }}
                        </v-btn>
                        <v-btn class="primary" type="submit">
                            {{ $gettext('Save') }}
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
            <snackbar ref="snackbar"></snackbar>
        </v-dialog>

    </div>
</template>
<style type="text/scss">
.add-rule-radio-margin .v-input--selection-controls {
    margin-top: 0;
}

</style>

<script>

import Vue from 'vue'

import Vuelidate from 'vuelidate'
import {minLength, required, requiredIf} from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinConfigUsers from '@/mixins/database/MixinConfigUsers'
import MixinVuelidate from '@/mixins/MixinVuelidate'
import {mapWritableState} from 'pinia'
import {useUsersStore} from '@/stores/UsersStore'
import {findIndex} from 'lodash'
import {useMdmStore} from '@/stores/MdmStore'

Vue.use(Vuelidate)


export default {
    components: {Snackbar},
    mixins: [MixinDialog, MixinIcon, MixinStringManipulation, MixinConfigUsers, MixinVuelidate],
    props: {
        params: {
            required: true,
            type: Object,
        },
    },
    watch: {

        // Mounted only fills in the dialog for the first time, the rest of the time it is filled by the watcher
        editCredentialsDialog(newVal) {
            let self = this

            if (newVal) {
                self.editLogin = self.$props.params.login
                self.editPassword = self.$props.params.password
            } else {
                self.resetForm()
            }

        },
    },
    mounted() {
        let self = this

        // Mounted only fills in the dialog for the first time, the rest of the time it is filled by the watcher
        self.editLogin = self.$props.params.login
        self.editPassword = self.$props.params.password

    },
    data() {
        return {

            editLogin: '',
            editPassword: '',
            userCategoryParentIndex: -1,
            userParentIndex: -1,
            deviceIndex: -1

        }
    },

    methods: {

        async processAddEditCredentials() {

            let self = this
            self.$v.$touch()
            await self.$v.$invalid
            await self.$nextTick()
            await self.$nextTick() // safety net

            setTimeout(() => {

                if (!self.$v.$invalid) {

                    let {
                        userCategoryIndex,
                        userIndex
                    } = self.configUserGetCategoryAndUserIndex(self.$props.params.userCategoryParent, self.$props.params.userParent)

                    if (userCategoryIndex !== -1 && userIndex !== -1) {
                        // Update credentials
                        Vue.set(self.users[userCategoryIndex]['value'][userIndex]['value'], 'login', self.editLogin)
                        Vue.set(self.users[userCategoryIndex]['value'][userIndex]['value'], 'password', self.editPassword)

                        // Emit an event to notify parent
                        self.$emit('credentials-updated', {
                            categoryIndex: userCategoryIndex,
                            userIndex: userIndex,
                            login: self.editLogin,
                            password: self.editPassword
                        })

                        this.$parent.$refs.snackbar.showSnackbar(this.$gettext('Credentials are updated successfully!'))
                    } else {
                        this.$parent.$refs.snackbar.showSnackbar(this.$gettext('Sorry! the credentials could not be updated'), 'error')
                    }

                    this.$parent.$refs.snackbar.showSnackbar(this.$gettext('Credentials are updated successfully!'))

                    self.closeAddEditCredentialsDialog()

                }

            }, 100)

        },

        closeAddEditCredentialsDialog() {
            let self = this
            // self.$emit('close-edit-device-name-dialog', 'editCredentialsDialog')
            self.$parent.closeDialog('addEditCredentialsDialog')
        },
        resetForm() {
            let self = this
            self.$v.$reset()
            self.editLogin = ''
            self.editPassword = ''
        },
    },
    computed: {

        ...mapWritableState(useMdmStore, {
            servers: 'servers'
        }),

        ...mapWritableState(useUsersStore, {
            users: 'users'
        }),

        editLoginErrors() {
            const errors = []
            if (!this.$v.editLogin.$dirty) return errors
            !this.$v.editLogin.required && errors.push(this.$gettext('Login is required'))

            return errors
        },

        editPasswordErrors() {
            const errors = []
            if (!this.$v.editPassword.$dirty) return errors
            !this.$v.editPassword.required && errors.push(this.$gettext('Password is required'))

            return errors
        },

        phoneServerErrors() {
            const errors = []
            if (!this.$v.phone.server.$dirty) return errors
            !this.$v.phone.server.required && errors.push(this.$gettext('Server is required'))

            return errors
        },

        phoneAccountErrors() {
            const errors = []
            if (!this.$v.phone.account.$dirty) return errors
            !this.$v.phone.account.required && errors.push(this.$gettext('Account is required'))

            return errors
        },

        phonePasswordErrors() {
            const errors = []
            if (!this.$v.phone.password.$dirty) return errors
            !this.$v.phone.password.required && errors.push(this.$gettext('Password is required'))

            return errors
        },

    },
    validations: {
        editPassword: {
            required
        },
        editLogin: {
            required
        }
    }

}
</script>
